import Quasar from 'quasar';
import langDa from 'quasar/lang/da';
import langEn from 'quasar/lang/en-us';

import moment from 'moment';

// @ts-ignore
import ValidatorEnLang from 'vee-validate/dist/locale/en.js';
// @ts-ignore
import ValidatorDaLang from 'vee-validate/dist/locale/da.js';
// @ts-ignore
import ValidatorAttrEnLang from '../../../strings/validator/attributes/en';
// @ts-ignore
import ValidatorAttrDaLang from '../../../strings/validator/attributes/da';

import { Validator } from 'vee-validate';

export class LocalizationHelpers {
    public static changePackagesLanguage(langKey: any) {
        const dictionary = {
            en: {
                attributes: ValidatorAttrEnLang,
                messages: ValidatorEnLang.messages,
            },
            da: {
                attributes: ValidatorAttrDaLang,
                messages: ValidatorDaLang.messages,
            },
        };

        switch (langKey) {
            case 'da':
                Quasar.lang.set(langDa);
                moment.locale('da');
                Validator.localize('da', dictionary.da);
                break;
            default:
                Quasar.lang.set(langEn);
                moment.locale('en-gb');
                Validator.localize('en', dictionary.en);
                break;
        }
    }
}
